// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 14 14", width: "14", height: "14" }, props),
        React.createElement(React.Fragment, null,
            React.createElement("g", { clipPath: "url(#InfoCircle14x14__a)" },
                React.createElement("mask", { id: "InfoCircle14x14__b", style: {
                        maskType: "luminance"
                    }, width: 14, height: 14, x: 0, y: 0, maskUnits: "userSpaceOnUse" },
                    React.createElement("path", { fill: "#fff", d: "M14 0H0V14H14V0Z" })),
                React.createElement("g", { mask: "url(#InfoCircle14x14__b)" },
                    React.createElement("path", { d: "M7 0C3.13425 0 0 3.1325 0 7C0 10.8657 3.13425 14 7 14C10.8658 14 14 10.8657 14 7C14 3.1325 10.8658 0 7 0ZM8 10.5C8 10.822 7.322 11.0833 7 11.0833C6.678 11.0833 6 10.822 6 10.5V6.5C6 6.178 6.678 5.83333 7 5.83333C7.322 5.83333 8 6.178 8 6.5V10.5ZM7 5C6.517 5 6 4.483 6 4C6 3.517 6.517 3 7 3C7.483 3 8 3.517 8 4C8 4.483 7.483 5 7 5Z" }))),
            React.createElement("defs", null,
                React.createElement("clipPath", { id: "InfoCircle14x14__a" },
                    React.createElement("path", { fill: "#fff", d: "M0 0H14V14H0z" }))))));
};
Icon.displayName = 'InfoCircle14x14';
export default Icon;
//# sourceMappingURL=InfoCircle14x14.js.map